import React from 'react'
import { Row, Col, Button } from 'react-bootstrap'
import DocumentTitle from 'react-document-title'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import Table from '_/shared/components/table'
import Filter from '_/shared/components/filter'
import Icon from '_/shared/components/icon'

/**
 * Group members
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class GroupMembers extends React.Component {
  static contextTypes = {
    store: React.PropTypes.object,
    router: React.PropTypes.func,
    notify: React.PropTypes.func
  }

  static propTypes = {
    account: React.PropTypes.object.isRequired,
    members: React.PropTypes.object.isRequired
  }

  static fetchData (store, { query }) {
    return {
      members: store.get('/members', {
        ...query,
        limit: 15
      })
    }
  }

  constructor (props, context) {
    super(props, context)
    this.state = { members: props.members }
  }

  async toggleAdminStatus (member, evt) {
    evt.preventDefault()
    const { store, notify } = this.context
    const { members } = this.state
    const id = member.get('id')
    const isGroupAdmin = member.get('isGroupAdmin')

    try {
      await store.post(`/members/${id}/toggleStatus`)
      this.setState({
        members: members.set('data', members.get('data').map(
          m => m.get('id') === member.get('id') ? m.set('isGroupAdmin', !isGroupAdmin) : m
        ))
      })
    }
    catch (er) {
      console.error(er)
      notify(er.response.body.error)
    }
  }

  async removeMember (member, evt) {
    evt.preventDefault()
    const { store, notify } = this.context
    const { members } = this.state
    const id = member.get('id')

    try {
      await store.delete(`/members/${id}`)
      this.setState({
        members: members
          .set('count', members.get('count') - 1)
          .set('data', members.get('data').filter(
            m => m.get('id') !== member.get('id')
          ))
      })
      notify('Member removed')
    }
    catch (er) {
      console.error(er)
      notify(er.response.body.error)
    }
  }

  renderToggleAdminStatus (member) {
    const { account } = this.props

    // Cannot toggle your own status
    if (member.get('id') === account.get('id')) return null

    const isGroupAdmin = member.get('isGroupAdmin')
    const icon = isGroupAdmin ? 'fa-check-square-o' : 'fa-square-o'

    return <a href="" onClick={this.toggleAdminStatus.bind(this, member)}><Icon name={icon}/></a>
  }

  renderRemove (member) {
    const { account } = this.props

    // Cannot remove yourself
    if (member.get('id') === account.get('id')) return null

    return (
      <a href="" onClick={this.removeMember.bind(this, member)}>
        <Icon name="fa-trash" />
      </a>
    )
  }

  render() {
    const query = this.context.router.getCurrentQuery()
    const { members } = this.state

    return (
      <DocumentTitle title="Manage group">
        <div>
          <Row>
            <Col xs={5}>
              <Button
                bsStyle="success"
                href="/account/invite">
                Invite new
              </Button>
            </Col>
            <Col xs={7}>
              <Filter
                {...query}
                route="group-members" />
            </Col>
          </Row>
          <Table
            {...query}
            route="group-members"
            limit={15}
            list={members}
            columns={[{
              name: 'email',
              width: 40,
              format: 'gravatar'
            }, {
              name: 'username',
              label: 'Username',
              sortable: true
            }, {
              name: 'name',
              label: 'Name',
              sortable: true
            }, {
              name: 'email',
              label: 'Email',
              format: 'email',
              sortable: true
            }, {
              label: 'Is admin?',
              width: 100,
              custom: ::this.renderToggleAdminStatus
            }, {
              width: 30,
              custom: ::this.renderRemove
            }]} />
        </div>
      </DocumentTitle>
    )
  }
}

export default GroupMembers



// WEBPACK FOOTER //
// ./modules/shared/pages/account/groupMembers.js